export enum Platforms {
  DESKTOP = 'desktop',
  MOBILE = 'mobile',
}

export const PlatformLabels = {
  [Platforms.DESKTOP]: 'Destkop',
  [Platforms.MOBILE]: 'Mobile',
}

export const PlatformDimensions = {
  [Platforms.DESKTOP]: { width: 2000, height: 414 },
  [Platforms.MOBILE]: { width: 661, height: 414 },
}
